import React, { useEffect, useState, useContext, useRef } from "react";
import { ModalContext } from "../Context/ModalContext";
//import { Navigation } from "react-minimal-side-navigation";
import AuthContextProvider, { AuthContext } from "../Context/AuthContext";
import useMedia from "../componentsofcourse/useMedia";
//import Modal from "react-modal";
import "../Assets/css/navbar.css";
import { Link, NavLink, Redirect, useHistory } from "react-router-dom";
import MainLogo from "../Assets/img/Home/cantileverlogo-cut.png";
import styles from "../Assets/css/form.module.css";

import { store } from "react-notifications-component";
import { DropdownComp } from "./DropdownComp";
import youtube from "../Assets/img/youtube.jpg";
import linkedin from "../Assets/img/linkedin.jpg";
import instagram from "../Assets/img/instagram.jpg";
import { BASE_URL } from "../env";
//import 'react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css';
import AOS from "aos";
import "aos/dist/aos.css";
import { Switch, useLocation } from "react-router-dom";
import { black } from "color-name";
import { Profiler } from "react";
import { developAxios } from "../axios.config";

//import { UserInformation } from "../App";
function Navbar(props) {
	const [LogoutDropDown, setLogoutDropdown] = useState(false);
	//const userinfo = useContext(UserInformation);
	const location = useLocation();
	let { open, update_current } = useContext(ModalContext);
	const [loggedIn, setLoggedin] = useState(false);
	const [showClose, setShowClose] = useState(false);
	const [firstName, setFirstName] = useState("");
	const [data, setData] = useState("");
	const [id, setId] = useState("");
	const [isAdmin, setIsAdmin] = useState(false);
	const history = useHistory();
	const [rotate, setrotate] = useState(false);
	const { token, update_token, set_Id } = useContext(AuthContext);
	const [NAME, setNAME] = useState("");
	//ids for the navlinks
	const ids = [
		"home",
		"aboutus",
		"blog",
		"dropdown-basic-course",
		"dropdown-basic-profile",
		"login",
	];

	//this is used for making the NavLink bold
	const handleClick = (event) => {
		for (let i = 0; i < ids.length; i++) {
			let x = document.getElementById(ids[i]);
			if (x != null && x.style.fontWeight === "600") {
				x.style.fontWeight = "lighter";
			}
		}
		if (event.target.id === "cp" || event.target.id === "gpr") {
			document.getElementById("dropdown-basic-course").style.fontWeight =
				"600";
		} else {
			event.target.style.fontWeight = "600";
		}
	};

	// useEffect(() => {
	//   setLogoutDropdown(false);
	//   if (loggedIn == false) {
	//     fetch(BASE_URL + "/getProfile", {
	//       headers: { authorization: "Bearer " + localStorage.getItem("token") },
	//     })
	//       .then((res) => res.json())
	//       .then((data) => {
	//         if (data.error) {
	//           setFirstName("");
	//         } else {
	//           setData(data);

	//           setLoggedin(true);
	//           setId(data.user._id);
	//           set_Id(data.user._id);
	//           setFirstName(data.user.firstName);
	//           setIsAdmin(data.user.isAdmin);
	//           setNAME(data.user.firstName);
	//         }
	//       })
	//       .catch(err => console.log(err.message));
	//   }
	// }, [token]);

	useEffect(() => {
		setLogoutDropdown(false);
		if (loggedIn == false) {
			developAxios(localStorage.getItem("token"))
				.get("/getProfile")
				.then(({ data }) => {
					if (data.error) {
						setFirstName("");
					} else {
						setData(data);
						setLoggedin(true);
						setId(data.user._id);
						set_Id(data.user._id);
						setFirstName(data.user.firstName);
						setIsAdmin(data.user.isAdmin);
						setNAME(data.user.firstName);
					}
				})
				.catch((err) => {
					if (err.response.status === 401) {
						localStorage.clear();
						update_token("");
						setLoggedin(false);
					}
				});
		}
	}, [token]);
	const notifyPopup = () => {
		store.addNotification({
			title: "Logged Out!",
			message: "You are Logged Out!",
			type: "danger",
			background: "pink",
			insert: "bottom",
			container: "bottom-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 3000,
				onScreen: true,
			},
		});
	};

	const logout = () => {
		localStorage.clear();
		update_token("");
		setLoggedin(false);
		notifyPopup();
	};
	function Rotation() {
		// setrotate(true);
		// setTimeout(() => {
		//   setrotate(false);
		// }, 2000);
	}

	function LoginComponent() {
		return (
			<>
				<Link
					id="login"
					to="/signin"
					activeClassName="active"
					className="nav-links text-dark"
					style={{
						textDecorationLine: "none",
						marginRight: "15px",
						fontWeight: "lighter",
					}}
					// className=" text-dark"
				>
					Login
				</Link>
			</>
		);
	}
	function LoggedInComponentWeb() {
		return (
			<>
				<ul className="row">
					<li className="row">
						{" "}
						design name
						<ul>
							<li className="row">Profile</li>

							<li className="row">Dashboard</li>
							<li className="row">Logout</li>
						</ul>
					</li>
				</ul>
			</>
		);
	}
	const [loggedinClick, setLoggedinClick] = useState(false);

	function LoggedInComponentMobile() {
		return (
			<>
				<div className="container-fluid">
					<Link
						className="row d-flex justify-content-center p-4 btn-lg btn-white"
						onClick={() => setLoggedinClick(!loggedinClick)}
					>
						{" "}
						<div
							className="col-sm-12 mx-auto d-flex justify-content-center"
							style={{ fontWeight: "bold" }}
						>
							{firstName.toUpperCase()}{" "}
							<i
								style={{ marginLeft: "2%", marginTop: "2%" }}
								className="fas fa-caret-down"
							></i>
						</div>
					</Link>
				</div>
				{loggedinClick == true ? (
					<div data-aos="fade-right">
						<Link
							to={{
								pathname: `/user/${id}`,
								state: {
									status: "dimple",
									data: data,
								},
							}}
							onClick={() => {
								handlehamclick();
								Rotation();
							}}
							className="row d-flex justify-content-center p-4 btn-lg btn-light"
							style={{
								borderBottomLeftRadius: "0px",
								borderBottomRightRadius: "0px",
							}}
						>
							{" "}
							Profile
						</Link>
						{isAdmin == true && (
							<>
								<div
									style={{
										backgroundColor: "#F9FAFB",
										width: "100%",
									}}
								>
									<div
										className="border mx-auto"
										style={{
											width: "80%",
											height: "3px",
											backgroundColor: "black",
											color: "black",
										}}
									></div>
								</div>
								<Link
									to="/addblog"
									onClick={() => {
										handlehamclick();
										Rotation();
									}}
									className="row d-flex justify-content-center p-4 btn-lg btn-light"
									style={{ borderRadius: "0px" }}
								>
									{" "}
									Create Blog
								</Link>
							</>
						)}

						{/* <Link
							to="/dashboard"
							onClick={() => {
								handlehamclick();
								Rotation();
							}}
							className="row d-flex justify-content-center p-4 btn-lg btn-light"
							style={{ borderRadius: "0px" }}
						>
							{" "}
							Dashboard
						</Link> */}
						<div
							style={{
								backgroundColor: "#F9FAFB",
								width: "100%",
							}}
						>
							<div
								className="border mx-auto"
								style={{
									width: "80%",
									height: "3px",
									backgroundColor: "black",
									color: "black",
								}}
							></div>
						</div>
						<Link
							to="/"
							onClick={() => {
								logout();
								handlehamclick();
							}}
							className="row d-flex justify-content-center p-4 btn-lg btn-light"
							style={{
								borderTopRightRadius: "0px",
								borderTopLeftRadius: "0px",
							}}
						>
							{" "}
							Log out
						</Link>
					</div>
				) : (
					<></>
				)}
			</>
		);
	}
	const [clickcourse, setclickcourse] = useState(false);
	const [click, setclick] = useState(false);
	const [dropdown, setdropdown] = useState(false);
	const [rotation, setrotation] = useState(true);
	const [coursesrotation, setcoursesrotation] = useState(true);

	// useEffect(() => {
	//   setrotation(true)
	// },[])

	const matches = useMedia("(min-width : 768px )");

	const handlehamclick = () => setclick(!click);

	const closeMobileMenu = () => setclick(false);

	if (token == "" && loggedIn == true) {
		setLoggedin(false);
	}
	useEffect(() => {
		AOS.init();
		var lastScrollTop = 0;
		const navbar = document.getElementById("newnavbar");
		window.addEventListener("scroll", () => {
			var scrolltop =
				window.pageYOffset || document.documentElement.scrollTop;
			if (scrolltop > lastScrollTop) {
				navbar.style.top = "-80px";
			} else {
				navbar.style.top = "0";
			}
			lastScrollTop = scrolltop;
		});
	});
	useEffect(() => {
		if (open == true) {
			setShowClose(true);
		} else {
			setShowClose(false);
		}
	}, [open]);
	return (
		<>
			<nav
				id="newnavbar"
				className="navbar p-0"
				style={{ position: "sticky", top: "0px", zIndex: "1" }}
			>
				<div
					className="menu-icon"
					onClick={handlehamclick}
					style={{ float: "left" }}
				>
					{/* <i className={click?'fas fa-times': 'fas fa-bars'}/> */}
					<div className={click ? "ham-btn open " : "ham-btn"}>
						<div className="ham-btn__burger"></div>
					</div>
				</div>
				<Link
					to="/"
					className="navbar-logo"
					style={{
						left: matches == false && "70%",
						bottom: matches == false && "40%",
					}}
				>
					<img
						className={rotate == true ? styles.rotateimg : null}
						onMouseOver={() => setrotate(true)}
						onMouseLeave={() => setrotate(false)}
						id="mainlogo"
						style={{
							width: "45px",
						}}
						src={MainLogo}
						width="30%"
					/>
				</Link>

				<ul
					style={{
						paddingLeft: matches == false ? "0px" : null,
						marginRight: "3%",
					}}
					className={click ? "nav-menu active" : "nav-menu"}
				>
					{/* this code is for the mobile version */}

					<>
						<li id="homes" className="nav-item">
							<NavLink
								exact
								to="/"
								id="home"
								className="nav-links"
								activeClassName="selected"
								style={{
									textDecorationLine: "none",
									// marginRight: "15px",
									color: "black",
								}}
							>
								Home
							</NavLink>
						</li>

						{/* this will be the drop down */}
						<li
							className="nav-item"
							onMouseEnter={() => {
								setcoursesrotation(false);
								setdropdown(true);
							}}
							onMouseLeave={() => setdropdown(false)}
						>
							<NavLink
								to="/cpcourse"
								// onClick={()=>history.push("/cpcourse")}
								className="nav-links new"
								id="dropdown-basic"
								activeClassName="selected"
								// classnmae="text-dark"
								// isActive={() =>
								//   ["/cpcourse", "/placementcourse"].includes(
								//     location.pathname
								//   )
								// }
								variant="success"
								style={{ color: "black" }}
							>
								Courses{" "}
								<i
									style={{
										transform:
											dropdown == true
												? "rotate(180deg)"
												: coursesrotation == false &&
												  "rotate(0deg)",
										animation:
											dropdown == true
												? "rotateNew 0.3s linear"
												: coursesrotation == false &&
												  "rotateBack 0.3s linear",
									}}
									className={`fas fa-caret-down rotate`}
								></i>
							</NavLink>
							{dropdown == true ? (
								<>
									<DropdownComp />
								</>
							) : null}
						</li>

						<li className="nav-item">
							<NavLink
								id="aboutus"
								to="/aboutus"
								activeClassName="selected"
								className="nav-links"
								style={{
									textDecorationLine: "none",
									marginRight: "15px",
									color: "black",
								}}
							>
								About us
							</NavLink>
						</li>
						<li className="nav-item">
							<NavLink
								id="blog"
								to="/blog"
								activeClassName="selected"
								className="nav-links"
								style={{
									textDecorationLine: "none",
									marginRight: "15px",
									color: "black",
								}}
							>
								Blog
							</NavLink>
						</li>

						<li className="nav-item">
							{token !== "" ? (
								<>
									<button
										// to="/"
										className="nav-links text-dark"
										onClick={(e) => {
											handleClick(e);
											closeMobileMenu();
											window.location.href = "/";
										}}
										activeClassName="active"
										style={{
											textDecorationLine: "none",
											marginRight: "15px",
											fontWeight: "lighter",
										}}
										// className=" text-dark"
									>
										<li
											className="nav-item"
											style={{ paddingTop: "0px" }}
											onMouseEnter={() => {
												setrotation(false);
												setLogoutDropdown(true);
											}}
											onMouseLeave={() =>
												setLogoutDropdown(false)
											}
										>
											<Link
												className="nav-links"
												style={{ color: "black" }}
												to="/"
											>
												<i class="fas fa-user-circle"></i>{" "}
												{NAME + " "}
												<i
													id="LOGOUT"
													style={{
														transform:
															LogoutDropDown ==
															true
																? "rotate(180deg)"
																: rotation ==
																		false &&
																  "rotate(0deg)",
														animation:
															LogoutDropDown ==
															true
																? "rotateNew 0.3s linear"
																: rotation ==
																		false &&
																  "rotateBack 0.3s linear",
													}}
													className={`fas fa-caret-down rotate`}
													// className="fas fa-caret-down"
												></i>
											</Link>
											{LogoutDropDown == true ? (
												<>
													<DropdownComp
														admin={isAdmin}
														props="logged in"
														token={token}
														name={firstName}
														LogoutMethd={() =>
															logout()
														}
														user_id={id}
														data={data}
													/>
												</>
											) : null}
										</li>
									</button>
								</>
							) : (
								<>
									<NavLink
										id="login"
										to="/signin"
										activeClassName="selected"
										className="nav-links"
										style={{
											textDecorationLine: "none",
											marginRight: "15px",
											bottom: "45px",
											color: "black",
										}}
									>
										Login
									</NavLink>
								</>
							)}
						</li>
					</>
				</ul>
			</nav>
		</>
	);
}

export default Navbar;
